<template>
  <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='initData' layout='inline'>
    <a-form-item>
      <a-select v-model:value="search.date" style="width:100px" @change="changDate">
        <a-select-option value="">自定义</a-select-option>
        <a-select-option value="7">近7天</a-select-option>
        <a-select-option value="30">近30天</a-select-option>
        <a-select-option value="month">月</a-select-option>
        <a-select-option value="year">年</a-select-option>
      </a-select>
      <a-input style="width: 50%" v-model:value="search.dateTarget" disabled v-if="search.date&&search.date!='7'&&search.date!='30'" />
    </a-form-item>
    <a-form-item label="">
      <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange"  :allowClear="false"/>
    </a-form-item>
    <a-form-item ref="" label="活动名称" name="">
      <a-input readonly placeholder="活动名称" v-model:value="search.activity_name" > </a-input>
    </a-form-item>
    <a-form-item>
      <a-button @click='search.activity_name="";search.activity_id=""'  class="m-r-5">重置</a-button>
      <a-button @click='activityVisible=true' type="primary" class="m-r-5">选择</a-button>
    </a-form-item>
    <a-form-item ref="" label="商品名称" name="">
      <a-input readonly v-model:value="search.product_name" placeholder="编号/名称" allowClear></a-input>
    </a-form-item>
    <a-form-item>
      <a-button @click='search.product_name="";search.product_id=""'  class="m-r-5">重置</a-button>
      <a-button @click='productVisible=true' type="primary">选择</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click='initData'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-card :bordered="false" v-if='!loading'>
    <lineCharts :series="series" :xAxis="xAxis" :dataName='["活动参与"]'  />
  </a-card>
  <div class="height-150 s_flex_center" v-else>
    <a-spin :spinning='loading' />
  </div>
  <a-table bordered :data-source="detail.list" :columns="columns" :loading='loading'>
    <template #attendNum>
      <span> 活动参与量<a-tooltip placement='right'>
          <template #title>统计二维码扫码参与活动的次数
          </template>
          <QuestionCircleOutlined />
        </a-tooltip></span>
    </template>
  </a-table>
  <!-- 活动弹窗 -->
  <a-modal  :keyboard="false" v-model:visible="activityVisible" centered style="width:700px" :width='1300'>
    <selectActivity v-on:select="activitySelect" :checkout='false' />
  </a-modal>
  <!-- 商品弹窗 -->
  <a-modal  :keyboard="false" v-model:visible="productVisible" centered :footer="null" style="width:700px" :width='1300'>
    <selectGood v-on:select="goodSelect" :selectList='[]'></selectGood>
  </a-modal>
</template>
<script>
import { inject, onMounted, ref } from "vue";
import lineCharts from "./line_charts.vue";
import { statisticsUser } from "@/api/qrcodeActivitys";
import {useTime} from '@/hooks/utils/useTime'
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
export default {
  name: "orderType",
  components: { lineCharts,QuestionCircleOutlined },
  setup() {
    const dataSource = ref([]);
    const columns = [
      {
        title: "日期",
        dataIndex: "date_time",
      },
        {
        dataIndex: "user_num",
        slots:{
          title:"attendNum"
        }
      }
    ];
    const time = ref([]);
    const search = ref({
      start_time: "",
      end_time: "",
      time: [],
      dateTarget: "",
      date: "7",
      order_source: "",
      day_type: 1,
      type: 1,
    });
    const detail = ref({ yesterdayData: {}, totalData: {} });
    const loading = ref(false);
    const series = ref([]);
    const xAxis = ref([]);
    const initData = async () => {
      loading.value = true;
      let result = await statisticsUser({...search.value})
        .then((res) => res.data)
        .catch((error) => error);
      detail.value = result.data;
      // 整合线图数据
      series.value = [
        {
          name: "活动参与",
          data: result.data.user_num_line,
          type: "line",
          symbolSize: 6,
        }
      ];
      xAxis.value = result.data.date_time_line;
      loading.value = false;
    };
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      search.value.date = "";
      initData();
    };

    // 活动弹窗
    const activityVisible = ref(false);
    const activitySelect = (data) => {
      search.value.activity_id = data.activity_id;
      search.value.activity_name = data.activity_name;
      activityVisible.value = false;
    };

    // 商品弹窗
    const productVisible = ref(false);
    const goodSelect = (data) => {
      search.value.product_name = data.product_name;
      search.value.product_id = data.id;
      productVisible.value = false;
    };
    // 切换时间类型
    // var $moment = inject("momentTime");
    const {typeToStartEnd,dateTargets}=useTime()
    const changDate = (e) => {
      var {start_time,end_time}=typeToStartEnd(e)
      search.value.start_time=start_time
      search.value.end_time=end_time
      search.value.time=[start_time,end_time]
      if(e=='month'||e=='year'){
        search.value.dateTarget=dateTargets(e)
      }
      initData();
    };
    onMounted(() => {
      changDate("7");
   // initData();
    });
    return {
      dataSource,
      columns,
      onChange,
      time,
      search,
      initData,
      loading,
      detail,
      series,
      xAxis,
      activityVisible,
      productVisible,
      activitySelect,
      goodSelect,
      changDate,
    };
  },
};
</script>
<style lang="less" scoped>
.card {
  height: 140px;
  border-radius: 8px;
  &:first-child {
    flex: 1;
  }
  &:nth-child(2) {
    flex: 2;
  }
  .card_main {
    height: 100%;
    .border-right {
      border-right: 1px solid #d0d9e3;
    }
    .card_items {
      border-radius: 5px;
      display: flex;
      flex: 1;
      align-items: center;
      height: 100%;
      .card_item {
        padding: 0 20px;
        height: 80%;
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h6 {
          font-size: 30px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 600;
          color: #333;
          line-height: 51px;
        }
        span {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #333;
          line-height: 24px;
        }
      }
    }
  }
}
</style>